// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as EditorialPolicyRouteImport } from './routes/editorial-policy'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as TermsConditionRouteImport } from './routes/terms-condition'
import { Route as ArticlesIndexRouteImport } from './routes/articles.index'
import { Route as ArticlesSlugRouteImport } from './routes/articles.$slug'
import { Route as AuthorJigneshMevadaRouteImport } from './routes/author.jignesh-mevada'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const EditorialPolicyRoute = EditorialPolicyRouteImport.update({
            id: '/editorial-policy',path: '/editorial-policy',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const TermsConditionRoute = TermsConditionRouteImport.update({
            id: '/terms-condition',path: '/terms-condition',getParentRoute: () => rootRouteImport
          })
const ArticlesIndexRoute = ArticlesIndexRouteImport.update({
            id: '/articles/',path: '/articles/',getParentRoute: () => rootRouteImport
          })
const ArticlesSlugRoute = ArticlesSlugRouteImport.update({
            id: '/articles/$slug',path: '/articles/$slug',getParentRoute: () => rootRouteImport
          })
const AuthorJigneshMevadaRoute = AuthorJigneshMevadaRouteImport.update({
            id: '/author/jignesh-mevada',path: '/author/jignesh-mevada',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRoute,ContactRoute: ContactRoute,EditorialPolicyRoute: EditorialPolicyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,TermsConditionRoute: TermsConditionRoute,ArticlesSlugRoute: ArticlesSlugRoute,AuthorJigneshMevadaRoute: AuthorJigneshMevadaRoute,ArticlesIndexRoute: ArticlesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)